
import React, { useState, useCallback } from "react";
import { DndProvider } from "react-dnd";
import Backend from 'react-dnd-html5-backend';
import { useDrag, useDrop } from "react-dnd";

import OutsideClickHandler from "react-outside-click-handler";
import SocialPack from "fantastic/components/common/controls/social/SocialPack";

const DraggableItem = ({ social, index, moveItem, updateSocialUrl, removeFromSocials }) => {

  const [, ref] = useDrag({
    item: { type: 'icon', index }
  });

  const [, drop] = useDrop({
    accept: 'icon',
    hover(item) {
      if (item.index !== index) {
        moveItem(item.index, index);
        item.index = index;
      }
    }
  });

  return (
    <div ref={node => ref(drop(node))} className="form-group fields" key={`social-id-${index}`} >
      <img src={`/social/${social.srv}_32.png`} />
      <input
        className="form-control fantastic-form-control"
        placeholder="http://..."
        value={social.url}
        onChange={(e) => updateSocialUrl(e, social)}
      />
      <a
        className="btn btn-link"
        onClick={() => removeFromSocials(social)}>
        <i className="fa fa-remove" />
      </a>
    </div>
  );
};

const SocialForm = (props) => {
  const { socials, onChange } = props;
  const [showSocialServices, displayServices] = useState(false)
  const socialPackProps = { ...props, displayServices }

  const toggleSocialServices = () => {
    displayServices(!showSocialServices)
  }

  const closeSocialServices = (e) => {
    if (e.target.id === "fa-plus-toggle") return null
    if (showSocialServices) return toggleSocialServices()
  };

  const updateSocialUrl = (e, currentSocial) => {
    const updatedSocials = socials.map((social) => {
      if (social.srv === currentSocial.srv) {
        return { srv: currentSocial.srv, url: e.target.value }
      } else {
        return { ...social }
      }
    })

    onChange('socials', updatedSocials)
  }

  const removeFromSocials = (currentSocial) => {
    const updatedSocials = socials.map((social) => {
      if (social.srv === currentSocial.srv) {
        return null
      } else {
        return { ...social }
      }
    }).filter((obj) => obj)

    onChange('socials', updatedSocials)
  }


  const moveItem = useCallback((fromIndex, toIndex) => {
    const newSocials = [...socials];
    const [movedItem] = newSocials.splice(fromIndex, 1);
    newSocials.splice(toIndex, 0, movedItem);
    onChange('socials', newSocials);
  }, [socials, onChange]);

  return (
    <DndProvider backend={Backend}>
      <div className="social-form">
        {socials.map((social, index) => (
          <DraggableItem
            key={index}
            index={index}
            social={social}
            moveItem={moveItem}
            updateSocialUrl={updateSocialUrl}
            removeFromSocials={removeFromSocials}
          />
        ))}
        <OutsideClickHandler onOutsideClick={closeSocialServices}>
          { showSocialServices && <SocialPack {...socialPackProps} /> }
        </OutsideClickHandler>

        <div className="form-group adds">
          <div className="dropup">
            <button
              className="btn btn-success"
              id="fa-plus-toggle"
              onClick={toggleSocialServices}>
              <i className="fa fa-plus" id="fa-plus-toggle"></i>
            </button>
          </div>
        </div>
      </div>
    </DndProvider>
  );
};

export default SocialForm;
